import React, { useEffect } from "react";
import DeleteIcon from "@material-ui/icons/Delete";
import styles from "../Events.module.css";
import Input from "../ReusableComp/Input";
import { useTranslation } from "react-i18next";
import downarrow_svg from "../../../Icons/Event/downarrow_svg.svg";
import uparrow_svg from "../../../Icons/Event/uparrow_svg.svg";

const CustomAction = (props) => {
  const { t } = useTranslation();
  const [input, setInput] = React.useState(props.defaultState || "");

  useEffect(() => {
    if (props.updateHandler) {
      props.updateHandler("CustomAction", input);
    }
  }, [input]);

  const handleInput = (x) => {
    setInput(x);
  };
  return (
    <div className={styles.tableclass}>
      <div className={styles.eventheader}>
        <span>{t("Custom Action")}</span>
        <span>
          <DeleteIcon
            onClick={() => {
              props.handleDelete(props.name);
            }}
          ></DeleteIcon>
          {
            props?.openedAccordian === props?.name
            ?
            <img
              src={downarrow_svg}
              onClick={()=>props.setopenedAccordian("")}
              style={{
                width:"24px", 
                height :"24px",
                margin:"0px 0 0 8px" 
              }}
            />
            :
            <img
              src={uparrow_svg}
              onClick={()=>props.setopenedAccordian(props?.name) }
              style={{
                width:"24px", 
                height :"24px",
                margin:"0px 0 0 8px" 
              }}
            />
          }
        </span>
      </div>
      <div className={styles.labelintable}>
        {t("Method Name")}
        <Input
          aria-label={"Method Name"}
          width={332}
          state={props.defaultState}
          handleInput={handleInput}
        ></Input>
      </div>
    </div>
  );
};

export default CustomAction;
